<template>
    <div>
        <v-card flat>
            <v-card-title>{{ examplefile.name }}</v-card-title>
            <v-card-text>
                <component
                    :is="examplefile.name_component"
                    :input="examplefile"
                    :constants="constants"
                    :valuelists="valuelists"
                />
            </v-card-text>
        </v-card>

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import ExampleSmartTable from "@/Pages/ExampleFile/Examples/ExampleSmartTable";
import ExampleConfirmDialog from "@/Pages/ExampleFile/Examples/ExampleConfirmDialog";
import ExampleSnackbar from "@/Pages/ExampleFile/Examples/ExampleSnackbar";
import ExampleChipSelect from "@/Pages/ExampleFile/Examples/ExampleChipSelect";
import ExampleRecordPickerDialog from "@/Pages/ExampleFile/Examples/ExampleRecordPickerDialog";
import ExampleEmails from "@/Pages/ExampleFile/Examples/ExampleEmails";

export default {
    name: "ExampleFileShow",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        ExampleEmails,
        ExampleChipSelect,
        ExampleConfirmDialog,
        ExampleRecordPickerDialog,
        ExampleSmartTable,
        ExampleSnackbar,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
        }
    },
    methods: {
        doSomething() {
            console.log(this.examplefile)
        },
    },
}
</script>

<style>

</style>
